export default "__VITE_ASSET__16cXE0$a__"